import { CodePenIframe } from "components/extra/CodePenIframe";

export function CodePenCard({ codepen = null }) {
    if (codepen === null) return <p>There was a problem with this CodePen.</p>
    const { user, title, hash, codePenFrame } = codepen;

    return (
        <div>
            <CodePenIframe
                user={user}
                hash={hash}
                title={title}
                codePenFrame={codePenFrame}
            />
        </div >
    )
}